/**
 * Playable Sonic Pi synthdefs (supersonic-scsynth-synthdefs@0.67.2).
 * Auto-generated — run build-instruments-manifest.js to refresh.
 */

const INSTRUMENT_MENU_ITEMS = [
    {
        "text": "bass foundation",
        "value": "sonic-pi-bass_foundation"
    },
    {
        "text": "bass highend",
        "value": "sonic-pi-bass_highend"
    },
    {
        "text": "beep",
        "value": "sonic-pi-beep"
    },
    {
        "text": "blade",
        "value": "sonic-pi-blade"
    },
    {
        "text": "bnoise",
        "value": "sonic-pi-bnoise"
    },
    {
        "text": "chipbass",
        "value": "sonic-pi-chipbass"
    },
    {
        "text": "chiplead",
        "value": "sonic-pi-chiplead"
    },
    {
        "text": "chipnoise",
        "value": "sonic-pi-chipnoise"
    },
    {
        "text": "cnoise",
        "value": "sonic-pi-cnoise"
    },
    {
        "text": "dark ambience",
        "value": "sonic-pi-dark_ambience"
    },
    {
        "text": "dpulse",
        "value": "sonic-pi-dpulse"
    },
    {
        "text": "dsaw",
        "value": "sonic-pi-dsaw"
    },
    {
        "text": "dtri",
        "value": "sonic-pi-dtri"
    },
    {
        "text": "dull bell",
        "value": "sonic-pi-dull_bell"
    },
    {
        "text": "fm",
        "value": "sonic-pi-fm"
    },
    {
        "text": "gabberkick",
        "value": "sonic-pi-gabberkick"
    },
    {
        "text": "gnoise",
        "value": "sonic-pi-gnoise"
    },
    {
        "text": "growl",
        "value": "sonic-pi-growl"
    },
    {
        "text": "hollow",
        "value": "sonic-pi-hollow"
    },
    {
        "text": "hoover",
        "value": "sonic-pi-hoover"
    },
    {
        "text": "kalimba",
        "value": "sonic-pi-kalimba"
    },
    {
        "text": "mod dsaw",
        "value": "sonic-pi-mod_dsaw"
    },
    {
        "text": "mod fm",
        "value": "sonic-pi-mod_fm"
    },
    {
        "text": "mod pulse",
        "value": "sonic-pi-mod_pulse"
    },
    {
        "text": "mod saw",
        "value": "sonic-pi-mod_saw"
    },
    {
        "text": "mod sine",
        "value": "sonic-pi-mod_sine"
    },
    {
        "text": "mod tri",
        "value": "sonic-pi-mod_tri"
    },
    {
        "text": "mono player",
        "value": "sonic-pi-mono_player"
    },
    {
        "text": "noise",
        "value": "sonic-pi-noise"
    },
    {
        "text": "organ tonewheel",
        "value": "sonic-pi-organ_tonewheel"
    },
    {
        "text": "piano",
        "value": "sonic-pi-piano"
    },
    {
        "text": "pluck",
        "value": "sonic-pi-pluck"
    },
    {
        "text": "pnoise",
        "value": "sonic-pi-pnoise"
    },
    {
        "text": "pretty bell",
        "value": "sonic-pi-pretty_bell"
    },
    {
        "text": "prophet",
        "value": "sonic-pi-prophet"
    },
    {
        "text": "pulse",
        "value": "sonic-pi-pulse"
    },
    {
        "text": "rhodey",
        "value": "sonic-pi-rhodey"
    },
    {
        "text": "rodeo",
        "value": "sonic-pi-rodeo"
    },
    {
        "text": "saw",
        "value": "sonic-pi-saw"
    },
    {
        "text": "sc808 bassdrum",
        "value": "sonic-pi-sc808_bassdrum"
    },
    {
        "text": "sc808 clap",
        "value": "sonic-pi-sc808_clap"
    },
    {
        "text": "sc808 claves",
        "value": "sonic-pi-sc808_claves"
    },
    {
        "text": "sc808 closed hihat",
        "value": "sonic-pi-sc808_closed_hihat"
    },
    {
        "text": "sc808 congahi",
        "value": "sonic-pi-sc808_congahi"
    },
    {
        "text": "sc808 congalo",
        "value": "sonic-pi-sc808_congalo"
    },
    {
        "text": "sc808 congamid",
        "value": "sonic-pi-sc808_congamid"
    },
    {
        "text": "sc808 cowbell",
        "value": "sonic-pi-sc808_cowbell"
    },
    {
        "text": "sc808 cymbal",
        "value": "sonic-pi-sc808_cymbal"
    },
    {
        "text": "sc808 maracas",
        "value": "sonic-pi-sc808_maracas"
    },
    {
        "text": "sc808 open hihat",
        "value": "sonic-pi-sc808_open_hihat"
    },
    {
        "text": "sc808 rimshot",
        "value": "sonic-pi-sc808_rimshot"
    },
    {
        "text": "sc808 snare",
        "value": "sonic-pi-sc808_snare"
    },
    {
        "text": "sc808 tomhi",
        "value": "sonic-pi-sc808_tomhi"
    },
    {
        "text": "sc808 tomlo",
        "value": "sonic-pi-sc808_tomlo"
    },
    {
        "text": "sc808 tommid",
        "value": "sonic-pi-sc808_tommid"
    },
    {
        "text": "square",
        "value": "sonic-pi-square"
    },
    {
        "text": "stereo player",
        "value": "sonic-pi-stereo_player"
    },
    {
        "text": "subpulse",
        "value": "sonic-pi-subpulse"
    },
    {
        "text": "supersaw",
        "value": "sonic-pi-supersaw"
    },
    {
        "text": "tb303",
        "value": "sonic-pi-tb303"
    },
    {
        "text": "tech saws",
        "value": "sonic-pi-tech_saws"
    },
    {
        "text": "tri",
        "value": "sonic-pi-tri"
    },
    {
        "text": "zawa",
        "value": "sonic-pi-zawa"
    }
];

module.exports = {
    INSTRUMENT_MENU_ITEMS
};
